import { store } from 'careand-redux/store';

class StripeUtils {
  getAPIKey(): string | null {
    const stripeModule = store.getState().authentication.settings?.modules?.stripe;
    return stripeModule?.public_key || null;
  }

  isEnabled(): boolean {
    const stripeModule = store.getState().authentication.settings?.modules?.stripe;
    return !!stripeModule?.enabled;
  }
}

export default new StripeUtils();
